import {
  convert,
  newDate,
  getFields,
  score,
  extractKeys,
  strIndex
} from '@/sui/data/flatten/tools'

import {
  addMO,
  findSurveillance,
  initializeSurveillance,
  neoOrigin,
  addBacteremia,
  ktDuration,
  unitType
} from '@/sui/data/flatten/common'

function future (o, v) {
  if (o == null || o === '') {
    return null
  }
  const value = parseInt(o)
  const values = [
    { index: 0, value: 1, code: 'DOM' },
    { index: 1, value: 2, code: 'ETAB' },
    { index: 2, value: 3, code: 'AUTETAB' },
    { index: 9, value: 9, code: 'NC' }
  ]

  const result = values.find(i => i.index === value)
  return v === 1 ? result.code : result.value
}

function addKT (prefix, target, parent, kt, v) {
  const type = v >= 2 ? c => c.type_v2 : c => c.type
  const config = [
    { key: 'type', get: type },
    { key: 'material', get: c => c.material },
    { key: 'insertion', get: c => newDate(c.insertion) },
    { key: 'insertion_site', get: c => c.insertionSite },
    { key: 'ventilation', get: c => c.ventilation },
    { key: 'lipids', get: c => c.lipids },
    { key: 'removed', get: c => c.removed },
    { key: 'removal', get: c => newDate(c.removal) },
    { key: 'removal_reason', get: c => c.removalReason },
    { key: 'duration', get: c => ktDuration(parent, c) },
    { key: 'laboratory', get: c => c.laboratory },
    { key: 'col_ilc_blc_sep', get: c => c.isColIlcBlcSep },
    { key: 'col_ilc_blc_sep_date', get: c => newDate(c.colIlcBlcSep) },
    { key: 'origin', get: c => c.colIlcBlcSepOrigin },
    { key: 'lipids_diagnosis', get: c => c.lipidsDiagnosis }
  ]

  if (v >= 3) {
    config.push(
      { key: 'blc_criteria', get: c => c.divDiag },
      { key: 'clinical_signs', get: b => b.clinicalSigns },
      { key: 'bio_signs', get: b => b.bioSigns },
      { key: 'adapted_antibio', get: b => b.adaptedAntibio },
      { key: 'two_hemocs', get: b => b.twoHemocs }
    )
  } else {
    config.push({ key: 'blc_criteria', get: c => c.blcCriteria })
  }

  if (v >= 2) {
    config.push(
      { key: 'diag_date', get: c => newDate(c.diagDate) },
      { key: 'covid', get: c => c.covidStatus }
    )
  }
  getFields(config, prefix, target, kt)
  if (kt.isColIlcBlcSep === 4) {
    ++target.kt_bact_count
  }

  kt.microOrganisms.forEach(
    (mo, i) => addMO(`${prefix}_99_mo${strIndex(i + 1)}`, target, mo, false, v >= 5 ? 'v2' : 'v1')
  )
}

function initializePatient (p, s, v) {
  const result = {
    type: 'neoInfADI',
    surv_id: p.sv
  }

  initializeSurveillance(result, s)

  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.sheet_number = p.f.sheetNumber
  result.birthdate = newDate(p.f.birthdate)
  result.sex = p.f.sex
  result.entry = newDate(p.f.entry)
  result.birth_site = p.f.birthSite
  if (v >= 2) {
    result.origin = p.f.origin
  } else {
    result.origin = neoOrigin(p.f.origin)
  }
  result.cribII = score('cribII', p.f.mainSeverity)
  result.other_score_name = p.f.otherSeverity.code
  result.other_score_value = p.f.otherSeverity.value
  result.birth_weight = p.f.birthWeight
  result.gestational_age = p.f.gestationalAge
  result.leucomalacy = p.f.leucomalacy
  result.dead = p.f.dead
  result.death = newDate(p.f.death)
  result.exit = newDate(p.f.exit)
  result.future = future(p.f.future, v)
  if (v >= 3) {
    result.covid = p.f.covidStatus
  }
  result.kt_count = p.f.catheters.length
  result.kt_bact_count = 0
  result.bact_count = p.f.bacteremias.length
  result.sepsis_count = p.f.sepsis.length
  return result
}

function addSepsis (prefix, target, sep, v) {
  const config = [
    { key: 'episod', get: c => newDate(c.episod) },
    { key: 'origin', get: c => c.origin }
  ]
  if (v >= 2) {
    config.push(
      { key: 'entrance', get: c => c.entrance_v2 },
      { key: 'diag_date', get: c => newDate(c.diagDate) },
      { key: 'covid', get: c => c.covidStatus }
    )
  } else {
    config.push(
      { key: 'entrance', get: c => c.entrance }
    )
  }
  if (v >= 4) {
    config.push({ key: 'lipids', get: c => c.lipids })
  }
  getFields(config, prefix, target, sep)
}

const reducer = (v) => (result, p) => {
  const s = findSurveillance(result, p)
  if (s != null && result.p.onlyClosed && s.status !== 'closed') {
    --result.r.length
    return result
  }

  const patient = initializePatient(p, s, v)
  if (result.keys == null) {
    result.keys = Object.keys(patient)
  }
  p.f.catheters.forEach(
    (c, i) => addKT(`kt${strIndex(i + 1)}`, patient, p.f, c, v)
  )

  const bv = [1, 2, 3, 3, 4]
  p.f.bacteremias.forEach(
    (b, i) => addBacteremia(`bact${strIndex(i + 1)}`, patient, p.f, b, bv[v - 1])
  )
  p.f.sepsis.forEach(
    (p, i) => addSepsis(`sep${strIndex(i + 1)}`, patient, p, v)
  )
  extractKeys(result, patient, ['kt', 'bact', 'sep'])
  result.r[result.i++] = patient
  return result
}

function run (v) {
  return (params) => convert(params, reducer(v), ['kt', 'bact', 'sep'])
}

export default {
  // 2019 sheets are migrated to 2020
  '2019': run(2),
  '2020': run(2),
  '2021': run(3),
  '2022': run(4),
  '2023': run(5),
  '2024': run(5),
  '2025': run(5),
  '2026': run(5)
}
